import React from "react";

interface SectionHeaderProps {
    title: string;
    subtitle?: string;
    action?: React.ReactNode;
    className?: string;
}

export function SectionHeader({
    title,
    subtitle,
    action,
    className = "",
}: SectionHeaderProps) {
    return <>{action && action}</>;
}
